module.exports = __webpack_public_path__ + "assets/mic.643c074b.svg";